'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function toggleable(fn) {
  var enabled = true;
  var isEnabled = function isEnabled() {
    return enabled;
  };
  var setEnabled = function setEnabled(state) {
    enabled = state;
  };
  var toggleableFn = function toggleableFn() {
    return fn(isEnabled).apply(undefined, arguments);
  };
  return Object.assign(toggleableFn, { setEnabled: setEnabled });
}

exports.default = toggleable;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.196/js/decorators/toggleable.js
// module id = 49
// module chunks = 0